import React, { useState, useEffect } from 'react';

import '../App.css';
import '../style/Home.css'
import Nav from '../components/Nav/Nav'
import Footer from '../components/Footer/Footer';
import waitress from '../img/waitress2.png'
import { ShopOutlined, StopOutlined, ShoppingOutlined, BarChartOutlined, CreditCardOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  IoFastFoodOutline,
  IoColorPaletteOutline,
  IoLibraryOutline,
  IoGameControllerOutline,
  IoShirtOutline,
  IoLogoTiktok,
} from "react-icons/io5";
import { MdOutlineBook } from "react-icons/md";
import { ImFileVideo } from "react-icons/im";
import { TbBread } from "react-icons/tb";


import { logEvent } from "firebase/analytics";
import { analytics } from "../Firebase";
import ReactPixel from "react-facebook-pixel";
import ContactModal from '../components/Modals/ContactModal';
import Faq from '../components/Faq';
import Features from '../components/Features';



function NewHome() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    ReactPixel.track("Lead", { content_name: `Bouton Start` })
    logEvent(analytics, 'Start')
    if (currentUser) {
      navigate(`/dashboard`)
    } else {
      navigate(`/login`)
    }
 
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <div>

      <div style={{ width: "100%" }}>
        <Nav home></Nav>
        <div className='wrapper-home'>
          <div className='header-txt-block'>
            <div className='header-title-block'>
              <h1 className='header-title'>Votre boutique en ligne gratuitement</h1>
            </div>
            <div className='header-subtitle-block'>
              <p className='header-subtitle'>
                Créez votre boutique en quelques minutes avec Fastline. Ajoutez vos produits et commencez à vendre immédiatement. Paiement et gestion des commandes intégrés. Aucun abonnement, une commission uniquement sur les ventes réalisées.               </p>
              <div className='main-button-container'>
                <button className='main-button' aria-label="Ouvrir le formulaire de contact" onClick={() => handleClick()}>Démarrer gratuitement</button>
                <button className='main-button demo-button ' aria-label="Ouvrir le formulaire de contact">
                  <a className='width100' aria-label="Ouvrir la démo d’un menu Fastline" rel="noreferrer" target="_blank" href="https://fastlineapp.com/shop/3rwautrq8oyZp2d3Y3By/menu" onClick={() => logEvent(analytics, 'view_demo')}>Voir la démo</a>
                </button>
              </div>

              {isOpen && <ContactModal setIsOpen={() => setIsOpen(false)} />}

            </div>


          </div>


          <div className='header-block-img header-img' style={{ backgroundImage: `url(${waitress})` }}>
            <div className="banner-filter filter-feature"></div>
          </div>
        </div>



        <div className="scroll-container" style={{ width: '100%', display: 'none' }} >
          <div className="scroll-content">
            {[

              '1.png',
              '2.png',
              '3.png',
              '4.png',
              '5.png',
              '6.png',

            ].map((logo, index) => (
              <img
                key={index}
                src={require(`../logos/${logo}`)}
                alt={`logo de partenaires -${index}`}
                className="scroll-logo"
              />
            ))}




            {/* Repeat the logos again for smooth infinite scroll */}

          </div>
        </div>

        <div className='advantages-wrapper'>
          <div className='advantages-title'>
            <h2>Une solution simple pour vendre en ligne</h2>
          </div>

          <div className='advantages-block'>

            <div className='advantage'>
              <ShopOutlined className='advantage-icon' />
              <h3>Création instantanée</h3>
              <p>Créez votre boutique en quelques minutes, sans aucune compétence technique. Tout est prêt pour commencer à vendre immédiatement.</p>
            </div>

            <div className='advantage'>
              <CreditCardOutlined className='advantage-icon' />
              <h3>Paiement intégré</h3>
              <p>Acceptez les paiements en ligne directement via Stripe. Encaissez simplement, en toute sécurité, sans configuration complexe.</p>
            </div>

            <div className='advantage'>
              <ShoppingOutlined className='advantage-icon' />
              <h3>Gestion des commandes</h3>
              <p>Recevez, suivez et gérez vos commandes depuis un seul espace. Tout est centralisé pour vous faire gagner du temps.</p>
            </div>

            <div className='advantage'>
              <IoLogoTiktok className='advantage-icon' />
              <h3>Partage facile</h3>
              <p>Partagez votre boutique via un lien ou vos réseaux sociaux. Permettez à vos clients de commander en quelques secondes.</p>
            </div>

            <div className='advantage'>
              <BarChartOutlined className='advantage-icon' />
              <h3>Suivi des performances</h3>
              <p>Accédez à vos ventes et statistiques directement via Stripe. Suivez vos revenus et analysez vos performances en temps réel.</p>
            </div>

            <div className='advantage'>
              <StopOutlined className='advantage-icon' />
              <h3>Sans abonnement</h3>
              <p>Aucun coût fixe. Vous payez uniquement une commission sur chaque vente. Démarrez votre activité librement.</p>
            </div>
          </div>
        </div>

        <div className='advantages-wrapper white-bg'>
            <div className='advantages-title'>
            <h2>Notre plateforme en 3 étapes</h2>
            </div>
            <div  className='advantages-bloc services-block'> 
            <Features></Features>
            </div> 
            </div>


        <div className='advantages-wrapper white-bg'>
          <div className='advantages-title center-bg'>
            <h2>Un outil adapté à tous types de produits</h2>
          </div>
          <div className='advantages-bloc services-block'>

            <section className="sectors">


              <article className="sector-card" style={{ cursor: 'pointer' }} onClick={() => window.open('https://fastlineapp.com/shop/6oFw9at4B8N9L3U9HwMf/menu', '_blank')}>
                <IoFastFoodOutline className="iconz" />
                <h3>Restauration</h3>
              </article>

              <article className="sector-card" style={{ cursor: 'pointer' }} onClick={() => window.open('https://fastlineapp.com/shop/3rwautrq8oyZp2d3Y3By/menu', '_blank')}>
                <MdOutlineBook className="iconz" />
                <h3>E-book</h3>
              </article>
             
              <article className="sector-card">
                <TbBread className="iconz" />
                <h3>Alimentaire</h3>
              </article>

               <article className="sector-card">
                <ImFileVideo className="iconz" />
                <h3>Formations</h3>
              </article>
 
 <article className="sector-card">
                <IoColorPaletteOutline className="iconz" />
                <h3>Art & Collections</h3>
              </article>


            

                 <article className="sector-card">
                <IoLibraryOutline className="iconz" />
                <h3>Culture et loisir</h3>
              </article>

              <article className="sector-card">
                <IoGameControllerOutline className="iconz" />
                <h3>High-Tech</h3>
              </article>

              <article className="sector-card">
                <IoShirtOutline className="iconz" />
                <h3>Mode & accessoires</h3>
              </article>
 
             
            </section>

          </div>
        </div>


        <div className='advantages-wrapper no-padding' data-nosnippet>
  <div className='advantages-title padding-title'>
    <h2>Ce que pensent nos clients</h2>
  </div>

  <div className='advantages-bloc services-block'>
    <div className="wrap">
      <div className="marquee">

        <div className='marquee__group'>

          <article className="cardz">
            <p className="quote">
              "J’ai lancé ma boutique sur Fastline sans prise de tête. Les produits sont simples à ajouter, les paiements sont intégrés et je peux suivre les commandes directement depuis mon espace."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Sarah.L<br />
                Glow Studio
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "Ce que j’aime, c’est que je peux commencer sans abonnement. Pour tester une idée ou vendre un premier produit, Fastline est beaucoup plus simple à prendre en main."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Mehdi.A<br />
                District Shop
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "La gestion des commandes est claire et le rendu de la boutique est propre sur mobile. Mes clients comprennent vite comment acheter, sans que j’aie besoin d’expliquer."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Camille.D<br />
                Atelier Nine
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "J’ai lancé ma boutique sur Fastline sans prise de tête. Les produits sont simples à ajouter, les paiements sont intégrés et je peux suivre les commandes directement depuis mon espace."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Sarah.L<br />
                Glow Studio
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "Ce que j’aime, c’est que je peux commencer sans abonnement. Pour tester une idée ou vendre un premier produit, Fastline est beaucoup plus simple à prendre en main."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Mehdi.A<br />
                District Shop
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "La gestion des commandes est claire et le rendu de la boutique est propre sur mobile. Mes clients comprennent vite comment acheter, sans que j’aie besoin d’expliquer."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Camille.D<br />
                Atelier Nine
              </p>
            </div>
          </article>

        </div>

        <div className='marquee__group'>

          <article className="cardz">
            <p className="quote">
              "J’ai lancé ma boutique sur Fastline sans prise de tête. Les produits sont simples à ajouter, les paiements sont intégrés et je peux suivre les commandes directement depuis mon espace."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Sarah.L<br />
                Glow Studio
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "Ce que j’aime, c’est que je peux commencer sans abonnement. Pour tester une idée ou vendre un premier produit, Fastline est beaucoup plus simple à prendre en main."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Mehdi.A<br />
                District Shop
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "La gestion des commandes est claire et le rendu de la boutique est propre sur mobile. Mes clients comprennent vite comment acheter, sans que j’aie besoin d’expliquer."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Camille.D<br />
                Atelier Nine
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "J’ai lancé ma boutique sur Fastline sans prise de tête. Les produits sont simples à ajouter, les paiements sont intégrés et je peux suivre les commandes directement depuis mon espace."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Sarah.L<br />
                Glow Studio
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "Ce que j’aime, c’est que je peux commencer sans abonnement. Pour tester une idée ou vendre un premier produit, Fastline est beaucoup plus simple à prendre en main."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Mehdi.A<br />
                District Shop
              </p>
            </div>
          </article>

          <article className="cardz">
            <p className="quote">
              "La gestion des commandes est claire et le rendu de la boutique est propre sur mobile. Mes clients comprennent vite comment acheter, sans que j’aie besoin d’expliquer."
            </p>
            <div className="footer">
              <p className="name"></p>
              <p className="meta">
                Camille.D<br />
                Atelier Nine
              </p>
            </div>
          </article>

        </div>

      </div>
    </div>
  </div>
</div>





        <div className='advantages-wrapper grey-bg pb-qna'>
          <div className='advantages-title center-bg'>
            <h2>Questions fréquentes</h2>
          </div>
          <div className='advantages-bloc services-block '>
            <Faq></Faq>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>

  )
}


export default NewHome



